// extracted by mini-css-extract-plugin
export default {"container":"MainIcon_container__eLWen","iconContainer":"MainIcon_iconContainer__vxiJ-","mainIconText":"MainIcon_mainIconText__yNSqN"};